import { FaClock, FaMapMarkerAlt, FaTimesCircle } from "react-icons/fa";
import { CurrencySimple, useResponsiveValue } from "../../utils/helper";
import { Button, Chip } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CancelIcon from "@mui/icons-material/Cancel";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';

export default function TripCard({ trip }) {
    const responsiveFontSize = useResponsiveValue({ xs: 26, sm: 26, lg: 26 });
    return (
        <div className="trip-card">

            {/* Header Row */}
            <div className="trip-header">

                <div className="trip-id-section">
                    <span className="trip-id-label">Trip ID</span>
                    <span className="trip-id-pill">{trip.id}</span>
                </div>

                <div className="">
                    {
                        trip?.travelStatus === 0 ? (
                            <Chip label="Trip Created" color="info" sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 1 ? (
                            <Chip label="Trip Completed" color="success" sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 2 ? (
                            <Chip label="Trip Inprogress" color="primary" sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 3 ? (
                            <Chip label="Driver Arrived" color="info" sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 4 ? (
                            <Chip label="Cancelled by Passenger" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 5 ? (
                            <Chip label="Trip Confirmed" color="primary" sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 6 ? (
                            <Chip label="Passenger Cancelled" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 8 ? (
                            <Chip label="Cancelled by Dispatcher" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 9 ? (
                            <Chip label="Trip Confirmed" color="primary" sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 12 ? (
                            <Chip label="Driver on the Way" color="info" sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 13 ? (
                            <Chip label="Driver Cancelled" color="error" icon={<CancelIcon />} sx={{ fontWeight: 500 }} />
                        ) : trip?.travelStatus === 16 ? (
                            <Chip label="Waiting For Approver Confirmation" color="warning" sx={{ fontWeight: 500 }} />
                        ) : (
                            <Chip label="Pending" color="default" sx={{ fontWeight: 500 }} />
                        )
                    }
                </div>

            </div>

            {/* Divider */}
            <div className="trip-divider"></div>

            {/* MAIN CONTENT WRAPPER */}
            <div className="trip-body">

                {/* LEFT DETAILS */}
                <div className="trip-details">
                    <div className="trip-row">
                        <AccessTimeIcon className="trip-icon" />
                        <span>{trip.time}</span>
                    </div>

                    <div className="trip-row">
                        <RoomOutlinedIcon className="trip-icon" />
                        <span>{trip?.location}</span>
                    </div>
                </div>

                {/* RIGHT AMOUNT */}
                {
                    trip?.amount &&
                    <div className="trip-amount">
                        <div className="amount-label">Amount</div>
                        <div className="amount-value">
                            {CurrencySimple(trip?.amount, "#4ea3a7", responsiveFontSize, "image", null)}
                        </div>
                        {
                            trip?.status === "Completed" &&
                            <Button
                                variant="contained"
                                startIcon={<WhatsAppIcon />}
                                sx={{
                                    backgroundColor: "#25D366",
                                    color: "white",
                                    textTransform: "none",
                                    borderRadius: "20px",
                                    "&:hover": { backgroundColor: "#1EBE5D" },
                                }}
                            >
                                Chat
                            </Button>
                        }
                    </div>
                }

            </div>
        </div>
    );
}
